export const ALERT_LEVEL = ['High', 'Medium', 'Low']
